// CANTEENEASY CODE BY FRANSISKA BUNADI - 1 April 2019
  // Store the referrer url to sessionstorage

$( document ).ready(function() {
    var referrer = document.referrer;
    var url_array = referrer.split('/');
    var length_array = url_array.length;

    if (typeof(Storage) !== "undefined") {

      if(url_array[length_array-2] =='products') {
          //$("#checkout_url").val(referrer);
        sessionStorage.setItem("lastProductURL", referrer);
      }
    }  
  });